document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const image = root.querySelector('#active-photo');
    const thumbs = [...root.querySelectorAll('.thumb')];
    const qty = root.querySelector('[data-qty]');
    const form = root.querySelector('.tds-purchase-form');
    const submit = root.querySelector('[data-add]');
    const label = root.querySelector('[data-add-text]');
    const cartAdd = root.querySelector('[data-cart-add]');
    const id = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const compare = root.querySelector('[data-compare]');
    const error = root.querySelector('[data-form-error]');
    let variants = [];
    try {variants = JSON.parse(document.getElementById(root.dataset.variantsId)?.textContent || '[]');} catch(e) {}
    const selects = [...root.querySelectorAll('.variant-select')];
    const money = cents => {try {return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(cents/100)} catch(e) {return (cents/100).toFixed(2)}};
    function setImage(url, alt, activeButton) {
      if (!image || !url) return;
      image.src = url; image.removeAttribute('srcset'); image.removeAttribute('sizes');
      if (alt) image.alt = alt;
      thumbs.forEach(b => {b.classList.toggle('active', b === activeButton);b.setAttribute('aria-pressed',String(b === activeButton))});
    }
    thumbs.forEach(b => b.addEventListener('click', () => setImage(b.dataset.image,b.dataset.alt,b)));
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {qty.value = Math.max(1,(parseInt(qty.value,10)||1)-1)});
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {qty.value = Math.min(20,(parseInt(qty.value,10)||1)+1)});
    function update(initial=false){
      if(!variants.length) return;
      const values=selects.map(s=>s.value);
      const v=variants.find(x=>x.options.every((o,i)=>o===values[i]));
      if(!v){submit.disabled=true;if(cartAdd)cartAdd.disabled=true;label.textContent='Unavailable';return}
      id.value=v.id;price.textContent=money(v.price);
      const sticky=root.parentElement.querySelector('[data-sticky-price]');if(sticky)sticky.textContent=money(v.price);
      if(!initial && location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
      compare.hidden=!(v.compare_at_price>v.price);
      if(!compare.hidden)compare.textContent=money(v.compare_at_price);
      submit.disabled=!v.available;if(cartAdd)cartAdd.disabled=!v.available;label.textContent=v.available?'Buy Now →':'Sold out';
      if(!initial && v.featured_image?.src){
        const matching=thumbs.find(b=>b.dataset.image?.split('?')[0]===v.featured_image.src.split('?')[0]);
        setImage(v.featured_image.src,v.featured_image.alt||'',matching);
      }
    }
    selects.forEach(s=>s.addEventListener('change',()=>update(false)));
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if(!id.value || submit.disabled) return;
      submit.disabled=true;label.textContent='Opening checkout…';error.hidden=true;
      try{
        const base=window.Shopify?.routes?.root||'/';
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(id.value),quantity:Math.max(1,Math.min(20,Number(qty.value)||1))}]})});
        if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||data.message||'Unable to add this item. Please try again.');}
        window.location.assign(base+'checkout');
      }catch(e){error.textContent=e.message||'Checkout could not be opened.';error.hidden=false;submit.disabled=false;label.textContent='Buy Now →';}
    });
    cartAdd?.addEventListener('click', async () => {
      if(!id.value || cartAdd.disabled) return;
      cartAdd.disabled = true;
      const oldLabel = cartAdd.textContent;
      cartAdd.textContent = 'Adding…';
      error.hidden = true;
      try {
        const base=window.Shopify?.routes?.root||'/';
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(id.value),quantity:Math.max(1,Math.min(20,Number(qty.value)||1))}]})});
        if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||data.message||'Unable to add this item.');}
        window.location.assign(base+'cart');
      } catch(e) {error.textContent=e.message||'Could not add item.';error.hidden=false;cartAdd.disabled=false;cartAdd.textContent=oldLabel;}
    });
    update(true);
  });
});

/* findgood direct-to-checkout forms; works with selected variant, no hard-coded variant IDs. */
document.addEventListener('submit', async function(event) {
 const form=event.target.closest('form[data-fg-direct-checkout]'); if(!form) return;
 if(!window.fetch || !window.FormData) return;
 event.preventDefault();
 const btn=form.querySelector('button[type="submit"]'); if(btn && btn.disabled)return;
 if(btn){btn.disabled=true;btn.dataset.label=btn.innerHTML;btn.textContent='Opening checkout…';}
 try {
  const response=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}});
  if(!response.ok){let result=await response.json().catch(()=>({}));throw new Error(result.description||'Unable to add this item. Please try again.');}
  window.location.assign('/checkout');
 } catch(e){if(btn){btn.disabled=false;btn.innerHTML=btn.dataset.label;}alert(e.message);}
});

